import { useSyncExternalStore } from "react";

/**
 * Where a computer opens a WhatsApp chat: the desktop APP or WhatsApp WEB
 * (Alex, 2026-10-21: "make it work for desktop app, not only browser").
 *
 * A web page cannot tell whether the desktop app is installed, and an app
 * link with no app installed does nothing at all, so this is each person's
 * own choice, remembered in their browser. Web by default: it works for
 * anyone logged in to WhatsApp Web, the app only where it is installed.
 * Phones ignore it and always use the app (see whatsappChatLink).
 *
 * localStorage is a per-viewer convenience here, so every read and write is
 * guarded: a private window or blocked storage just means Web every time.
 */
export const WHATSAPP_TARGET_KEY = "rc.tradeFeed.whatsappTarget";
const KEY = WHATSAPP_TARGET_KEY;
const listeners = new Set();

export const getWhatsappTarget = () => {
  try {
    return window.localStorage.getItem(KEY) === "app" ? "app" : "web";
  } catch {
    return "web";
  }
};

export const setWhatsappTarget = (target) => {
  try {
    window.localStorage.setItem(KEY, target === "app" ? "app" : "web");
  } catch {
    // Not remembered; the choice still applies until the page reloads.
  }
  listeners.forEach((fn) => fn());
};

const subscribe = (fn) => {
  listeners.add(fn);
  // Another tab changing it.
  const onStorage = (e) => {
    if (e.key === KEY) fn();
  };
  window.addEventListener("storage", onStorage);
  return () => {
    listeners.delete(fn);
    window.removeEventListener("storage", onStorage);
  };
};

/** The current choice, re-rendering every card when it changes. */
export const useWhatsappTarget = () => useSyncExternalStore(subscribe, getWhatsappTarget, () => "web");
